// extracted by mini-css-extract-plugin
export default {"proseRoot":"richTextProse-module__rfrNc","previewReadOnly":"richTextProse-module__pBxPw","proseRootListRow":"richTextProse-module__yH4Zg"};